/**
 * Evaluates if a value is true, or a stringified true value
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isTruthy = (value: any): boolean =>
  ['true', '1'].includes(value?.toString()?.trim());
